<template>
  <div class="experience">
    <AppBar />
    <div class="page-content">
      <div class="content">
        <div class="content-left">
          <div class="title">产品体验</div>
          <div class="describe">选择华跃，拥有先进的人才管理能力</div>
        </div>
        <div class="content-right">
          <div class="content-from-title">产品体验申请</div>
          <div v-if="!complete" class="content-from-wrap">
            <div class="from-box">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-input
                    v-model="experienceform.name"
                    placeholder="客户名称"
                  />
                </el-col>
                <el-col :span="12">
                  <el-select v-model="experienceform.value" placeholder="行业">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-input
                    v-model="experienceform.contacts"
                    placeholder="客户联系人"
                  />
                </el-col>
                <el-col :span="12">
                  <el-input
                    v-model="experienceform.telephone"
                    placeholder="联系电话"
                  />
                </el-col>
              </el-row>
              <div class="module-list-wrap">
                <div class="wrap-text">希望体验的功能板块</div>
                <div class="list-box">
                  <div
                    v-for="(item, index) in functionList"
                    :key="index"
                    class="list-item"
                    @click="onXuanZhong(item, 'functionItem')"
                  >
                    <div
                      class="xuanzhong"
                      :class="{ isxuanzhong: xuanZhong(item, 'functionItem') }"
                    ></div>
                    <div class="item-text">{{ item.text }}</div>
                  </div>
                </div>
              </div>
              <div class="module-list-wrap">
                <div class="wrap-text">希望体验的周期</div>
                <div class="list-box">
                  <div
                    v-for="(item, index) in cycleList"
                    :key="index"
                    class="list-item"
                    @click="onDanZhong(item, 'cycleItem')"
                  >
                    <div
                      class="danxuan"
                    >
                      <!-- :class="{ isxuanzhong: xuanZhong(item, 'cycleItem') }" -->
                      <div v-if="experienceform.cycleItem === item.id" class="isdanzhong"></div>
                    </div>
                    <div class="item-text">{{ item.text }}</div>
                  </div>
                </div>
              </div>
              <div class="module-list-wrap">
                <div class="wrap-text">体验技术支持</div>
                <div class="list-box">
                  <div
                    v-for="(item, index) in supportList"
                    :key="index"
                    class="list-item"
                    @click="onXuanZhong(item, 'supportItem')"
                  >
                    <div
                      class="xuanzhong"
                      :class="{ isxuanzhong: xuanZhong(item, 'supportItem') }"
                    ></div>
                    <div class="item-text">{{ item.text }}</div>
                  </div>
                </div>
              </div>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-input
                    v-model="experienceform.counterpart"
                    placeholder="商务对接人"
                  />
                </el-col>
                <el-col :span="12">
                  <el-input
                    v-model="experienceform.counterpartTel"
                    placeholder="对接人手机号码"
                  />
                </el-col>
              </el-row>
            </div>
            <div class="content-from-buttom">
              <div
                class="buttom"
                :class="{
                  submit:
                    experienceform.name !== '' &&
                    experienceform.value !== '' &&
                    experienceform.contacts !== '' &&
                    experienceform.telephone !== '' &&
                    experienceform.functionItem.length !== 0 &&
                    experienceform.cycleItem !== '' &&
                    experienceform.supportItem.length !== 0 &&
                    experienceform.counterpart !== '' &&
                    experienceform.counterpartTel !== '',
                }"
                @click="submitForm"
              >
                提交申请
              </div>
            </div>
          </div>
          <div v-else class="complete-wrap">
            <div class="complete-top">
              <div class="icon-box">
                <svg
                  t="1670464856041"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="2927"
                  width="15"
                  height="15"
                >
                  <path
                    d="M940.8 160L396.8 704 83.2 384 0 467.2l313.6 313.6 83.2 83.2L1024 243.2z"
                    fill="#fff"
                    p-id="2928"
                  />
                </svg>
              </div>
              <div class="text">提交成功</div>
            </div>
            <div class="complete-center">
              我们已经收到您的体验申请，专属顾问将会在1个工作日内与您联系
            </div>
            <div class="complete-buttom" @click="returnFrom">返回首页</div>
          </div>
        </div>
      </div>
    </div>
    <RightFixedgt />
    <FootWrap />
    <AltProduct ref="altProduct" />
    <ast ref="ast" />
  </div>
</template>

<script>
import { getColumnChild } from '@/api/column'
import { submitForm } from '@/api/content';
export default {
  name: 'ExperienceViwe',
  data() {
    return {
      complete: false,
      experienceform: {
        name: '',
        value: '',
        contacts: '',
        telephone: '',
        functionItem: [],
        cycleItem: '',
        supportItem: [],
        counterpart: '',
        counterpartTel: '',        
      },
      options: [
        // {
        //   value: 0,
        //   label: '五金行业',
        // },
        // {
        //   value: 1,
        //   label: '电子电器',
        // },
        // {
        //   value: 2,
        //   label: '综合集团',
        // },
        // {
        //   value: 3,
        //   label: '食品行业',
        // },
      ],
      functionList: [
        {
          id: 0,
          text: '战略组织',
        },
        {
          id: 1,
          text: '员工关系',
        },
        {
          id: 2,
          text: '考勤工时',
        },
        {
          id: 3,
          text: '薪酬福利',
        },
        {
          id: 4,
          text: '绩效激励',
        },
        {
          id: 5,
          text: '人才发展',
        },
        {
          id: 6,
          text: '计件工资',
        },
        {
          id: 7,
          text: '移动平台',
        },
        {
          id: 8,
          text: '人才招聘',
        },
        {
          id: 9,
          text: '人才培育',
        },
        {
          id: 10,
          text: '人才测评',
        },
        {
          id: 11,
          text: '报表工具',
        },
      ],
      cycleList: [
        {
          id: 0,
          text: '一周',
        },
        {
          id: 1,
          text: '两周',
        },
        {
          id: 2,
          text: '三周',
        },
        {
          id: 3,
          text: '一个月',
        },
      ],
      supportList: [
        {
          id: 0,
          text: '是否需要上门培训',
        },
        {
          id: 1,
          text: '是否需要测试数据',
        },
        {
          id: 2,
          text: '是否需要签订试用协议',
        },
      ],
    };
  },
  mounted() {
    this.getOptionsList();
  },
  methods: {
    getOptionsList() {
      getColumnChild({ parentId: '1605405080163672064', }).then((res) => {
        const { result, } = res;
        for (var i = 0; i < result.length; i++) {
          this.options.push({
            value: result[i].id,
            label: result[i].name
          })
        }
      })
    },
    onXuanZhong(item, key) {
      var index = this.experienceform[key].indexOf(item.id);
      if (index === -1) {
        this.experienceform[key].push(item.id);
      } else {
        this.experienceform[key].splice(index, 1);
      }
    },
    xuanZhong(item, key) {
      var index = this.experienceform[key].indexOf(item.id);
      if (index === -1) {
        return false;
      } else {
        return true;
      }
    },
    onDanZhong(item, key) {
      this.experienceform[key] = item.id;
    },
    submitForm() {
      if (
        this.experienceform.name !== '' &&
        this.experienceform.value !== '' &&
        this.experienceform.contacts !== '' &&
        this.experienceform.telephone !== '' &&
        this.experienceform.functionItem.length !== 0 &&
        this.experienceform.cycleItem !== '' &&
        this.experienceform.supportItem.length !== 0 &&
        this.experienceform.counterpart !== '' &&
        this.experienceform.counterpartTel !== ''
      ) {
        var element = {
          name: {
            elementType: 'text',
            content: this.experienceform.name,
          },
          value: {
            elementType: 'radio',
            content: this.experienceform.value,
          },
          contacts: {
            elementType: 'text',
            content: this.experienceform.contacts,
          },
          telephone: {
            elementType: 'text',
            content: this.experienceform.telephone,
          },
          functionItem: {
            elementType: 'checkbox',
            content: this.experienceform.functionItem,
          },
          cycleItem: {
            elementType: 'radio',
            content: this.experienceform.cycleItem,
          },
          supportItem: {
            elementType: 'checkbox',
            content: this.experienceform.supportItem,
          },
          counterpart: {
            elementType: 'text',
            content: this.experienceform.counterpart,
          },
          counterpartTel: {
            elementType: 'text',
            content: this.experienceform.counterpartTel,
          },
        };
        var formData = {
          formId: '1605845734920511488',
          element,
        };
        submitForm(formData).then((res) => {
          if (res.code === 200) {
            this.complete = true;
            this.experienceform = {
              name: '',
              value: '',
              contacts: '',
              telephone: '',
              functionItem: [],
              cycleItem: '',
              supportItem: [],
              counterpart: '',
              counterpartTel: '',
            };
          }
        });
      }
    },
    returnFrom() {
      this.complete = false;
      this.experienceform = {
        name: '',
        value: '',
        contacts: '',
        telephone: '',
        functionItem: [],
        cycleItem: '',
        supportItem: [],
        counterpart: '',
        counterpartTel: '',
      };
    },
    openBealter() {
      this.$refs.altProduct.tobealter();
    },
    openBealter2() {
       this.$refs.ast.drawer  = true
    },
  },
};
</script>

<style lang="less" scoped>
.experience {
  width: 100%;
  background: #fff;
  position: relative;
  .page-content {
    width: 100%;
    height: 845px;
    min-width: 1200px;
    background: url("@/assets/experience/canvas.png") no-repeat;
    background-size: cover;
    background-position: center;
    .content {
      width: 1200px;
      height: 100%;
      padding: 80px 0;
      margin: 0 auto;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      .content-left {
        flex: 1;
        .title {
          font-family: OPPOSans-R;
          font-size: 40px;
          color: #21252b;
          margin-bottom: 28px;
        }
        .describe {
          font-family: OPPOSans-R;
          font-size: 16px;
          color: #21252b;
        }
      }
      .content-right {
        width: 615px;
        padding: 30px;
        box-sizing: border-box;
        background-color: #fff;
        border-radius: 12px;
        .content-from-title {
          width: 100%;
          font-family: OPPOSans-M;
          font-size: 22px;
          color: #21252b;
          padding-bottom: 24px;
          border-bottom: 1px solid #e8eaed;
        }
        .content-from-wrap {
          .el-row {
            margin-bottom: 15px;
            &:last-child {
              margin-bottom: 0;
            }
          }
          .from-box {
            padding: 30px 0;
            border-bottom: 1px solid #e8eaed;
            .module-list-wrap {
              width: 100%;
              .wrap-text {
                font-size: 12px;
                font-family: OPPOSans-R;
                color: #737c8b;
                margin-bottom: 20px;
              }
              .list-box {
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                justify-content: flex-start;
                .list-item {
                  width: 28%;
                  display: flex;
                  align-items: center;
                  justify-content: flex-start;
                  // margin-right: 75px;
                  margin-bottom: 24px;
                  cursor: pointer;
                  .xuanzhong {
                    width: 16px;
                    height: 16px;
                    background-color: #fff;
                    border-radius: 4px;
                    border: 1px solid #dee0e3;
                    background-repeat: no-repeat;
                    background-position: center;
                    transition: all 0.3s ease-in-out;
                    box-sizing: border-box;
                    margin-right: 8px;
                  }
                  .isxuanzhong {
                    background-image: url("@/assets/altProduct/zhengque.png");
                    background-color: #00b0dc;
                    border-color: #00b0dc;
                  }
                  .danxuan{
                    width: 16px;
                    height: 16px;
                    background-color: #fff;
                    border-radius: 50%;
                    border: 1px solid #dee0e3;
                    transition: all 0.3s ease-in-out;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    box-sizing: border-box;
                    margin-right: 8px;
                  }
                  .isdanzhong{
                    width: 8px;
                    height: 8px;
                    background-color: #00b0dc;
                    border-radius: 50%;
                  }
                  .item-text {
                    font-family: OPPOSans-R;
                    font-size: 14px;
                    color: #181818;
                    line-height: 1;
                  }
                  &:nth-child(4n) {
                    flex: 1;
                    margin-right: 0;
                  }
                  &:last-child {
                    flex: 1;
                  }
                }
              }
            }
            ::v-deep .el-select {
              width: 100%;
            }
          }
          .content-from-buttom {
            width: 100%;
            display: flex;
            margin-top: 20px;
            .buttom {
              width: 267px;
              height: 40px;
              background-color: #e0e5f0;
              border-radius: 4px;
              text-align: center;
              line-height: 40px;
              font-size: 14px;
              color: #8893a9;
              cursor: initial;
            }
            .submit {
              cursor: pointer;
              color: #fff;
              background-color: #00b0dc;
            }
          }
        }
        .complete-wrap {
          padding: 50px 0 80px;
          display: flex;
          flex-direction: column;
          align-items: center;
          .complete-top {
            display: flex;
            align-items: center;
            margin-bottom: 25px;
            .icon-box {
              width: 28px;
              height: 28px;
              background-color: #13d47e;
              border-radius: 50%;
              display: flex;
              justify-content: center;
              align-items: center;
              margin-right: 10px;
            }
            .text {
              font-size: 18px;
              font-family: OPPOSans-M;
              color: #21252b;
            }
          }
          .complete-center {
            font-family: OPPOSans-R;
            font-size: 14px;
            color: #21252b;
            margin-bottom: 40px;
          }
          .complete-buttom {
            width: 248px;
            height: 40px;
            background-color: #00b0dc;
            border-radius: 4px;
            font-size: 14px;
            color: #fff;
            text-align: center;
            line-height: 40px;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
